import { PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  payment_methods: {
    [PaymentMethod.Card]: 'Tarjeta de crédito',
    [PaymentMethod.Sofort]: 'Sofort',
    [PaymentMethod.Giropay]: 'Giropay',
    [PaymentMethod.PayByBank]: 'Pagar con banco',
    [PaymentMethod.SepaDebit]: 'EC-Card / IBAN',
    [PaymentMethod.Cash]: 'Efectivo',
    [PaymentMethod.Link]: 'Link',
    [PaymentMethod.StripeOther]: 'Otro método de pago',
  },
};
